import { FC, RefObject, useCallback, useEffect, useRef } from "react";
import { Row } from "../../containers";
import { SearchInputProps } from "./types";
import { useThemeStore } from "../../../stores";
import { JustifyContent } from "../../containers/types";
import { IconAnimation } from "../../animation";
import { SearchIcon } from "../../../assets/icons";

const SearchInput: FC<SearchInputProps> = ({
  value,
  props,
  setValue = () => {},
  label = "جستجو",
  className = "",
  style = {},
  color,
}) => {
  const theme = useThemeStore((s) => s.theme);
  const ref: RefObject<HTMLInputElement> = useRef<HTMLInputElement>(null);

  const handler = useCallback(
    (e: MouseEvent): void => {
      if ((e.target as Element).tagName.toLowerCase() !== "input") {
        ref.current?.blur();
      }
    },
    [ref]
  );

  useEffect(() => {
    window.addEventListener("click", handler);
    return (): void => {
      window.removeEventListener("click", handler);
    };
  }, [handler]);

  return (
    <Row
      style={{
        width: "100%",
        border: `1px solid ${theme.icon}`,
        borderRadius: 15,
        minHeight: 32,
        ...style,
      }}
      justifyContent={JustifyContent.Between}
      className={className}
      props={props}
    >
      <input
        ref={ref}
        style={{
          minHeight: 32,
          width: "calc(100% - 1rem)",
          height: "100%",
          background: "transparent",
          color: color || theme.textOnBg,
          paddingRight: "1rem",
        }}
        placeholder={label}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
      <IconAnimation
        Icon={SearchIcon}
        onHoverColor={theme.primary}
        style={{ cursor: "pointer", marginLeft: 8 }}
        width={20}
        height={20}
      />
    </Row>
  );
};

export default SearchInput;
